import { useState, useMemo } from "react";
import { useParams, Navigate } from "react-router-dom";
import { toast } from "sonner";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEOHead from "../components/SEOHead";
import IntegrationDetailPage from "../components/IntegrationDetailPage";
import { integrations, getIntegrationById } from "../data/integrations";

import { useTranslation } from 'react-i18next';
export default function IntegrationDetailRoute() {
  const { t } = useTranslation();
  const { id } = useParams();
  const [connectedIds, setConnectedIds] = useState(
    integrations.filter((i) => i.status === "connected").map((i) => i.id)
  );

  const integration = useMemo(() => getIntegrationById(id), [id]);

  if (!integration) {
    return <Navigate to="/marketplace/integrations" replace />;
  }

  const isConnected = connectedIds.includes(integration.id);

  const handleConnect = (integrationId) => {
    setConnectedIds((prev) => [...prev, integrationId]);
    toast.success(`${integration.name} connected successfully`);
  };

  const handleDisconnect = (integrationId) => {
    setConnectedIds((prev) => prev.filter((cid) => cid !== integrationId));
    toast.info(`${integration.name} disconnected`);
  };

  return (
    <>
      <SEOHead
        title={`${integration.name} Integration — Max Employee`}
        description={integration.description}
        url={`/marketplace/integrations/${integration.id}`}
      />
      <Header />
      <IntegrationDetailPage
        integration={integration}
        isConnected={isConnected}
        onConnect={handleConnect}
        onDisconnect={handleDisconnect}
      />
      <Footer />
    </>
  );
}
